import React, { useEffect, useState } from "react";
import { ReactComponent as CallIcon } from "../../../../../../assets/map/call.svg";
import { ReactComponent as PhoneDark } from "../../../../../../assets/map/Phone_Dark.svg";
import { ReactComponent as LocationIcon } from "../../../../../../assets/map/location.svg";
import { ReactComponent as EditIcon } from "../../../../../../assets/MainPage/addBlock/location/edit-2.svg";
import { ReactComponent as TrashIcon } from "../../../../../../assets/MainPage/addBlock/location/trash-icon.svg";
import { ReactComponent as HomeIcon } from "../../../../../../assets/map/House.svg";
import { ReactComponent as HomeIconDark } from "../../../../../../assets/map/House_Dark.svg";
import useSettings from "../../../../../../hooks/useSettings";
import useLocales from "../../../../../../hooks/useLocales";
import httpRequest from "../../../../../../axios/index";

import {
  setShowForm,
  setShowLocationData,
  setEditingLocation,
} from "../../../../../../redux/slices/location/locationSlice";

import { ReactComponent as LeftArrow } from "../../../../../../assets/arrow-left.svg";
import { Link, useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModalLocation from "../../../../../../components/dashboard/modal/ConfirmModalLocation";

const LocationFormData = ({ locationMap, getLocationMapData }) => {
  const { darkMode } = useSelector((state) => state.theme);

  const { translate, currentLang } = useLocales();
  const dispatch = useDispatch();

  const [locationToDelete, setLocationToDelete] = useState(null); // State to store ID of location to be deleted

  const [isModalOpen, setIsModalOpen] = useState(false);

  // const [locationMap, setLocationMap] = useState([])
  const { themeDirection } = useSettings();

  // useEffect(() => {
  //   getLocationMapData()
  // }, [])

  // const getLocationMapData = async () => {
  //   const { userid } = JSON.parse(localStorage.getItem('user'))
  //   try {
  //     const url = `api/user/maps/${userid}`

  //     const response = await httpRequest.get(url)
  //     const resultSuccess = response?.data?.data
  //     const status = response?.data?.status

  //     if (status === 'success') {
  //       setLocationMap(resultSuccess)
  //     }
  //   } catch (error) {
  //     if (error?.response?.data?.status === 'failed') {
  //       toast.error(error?.response?.data?.message)
  //     } else {
  //       toast.error('Something went wrong')
  //     }
  //   }
  // }
  const navigate = useNavigate();

  const handleEditLocation = async (id) => {
    // navigate(`/dashboard/component/editLocationForm/${id}`)
    dispatch(setShowForm(false));
    dispatch(setShowLocationData(false));
    dispatch(setEditingLocation(id));
  };

  const handleDeleteLocation = async () => {
    const { userid } = JSON.parse(localStorage.getItem("user"));
    const linkid = localStorage.getItem("linkId");

    const locationToDeleteData = locationMap?.find(
      (item) => item._id === locationToDelete
    );
    if (!locationToDeleteData) {
      toast.error("Location not found");
      return;
    }

    const { language } = locationToDeleteData;

    const payload = {
      coloum_name: "mapData",
      coloum_type: "mapData",
      link_id: linkid,
      userId: userid,
      language: language,
    };
    try {
      const url = `/api/user/maps/${locationToDelete}/${payload?.link_id}/${payload?.userId}/${payload?.coloum_name}/${payload?.coloum_type}/${payload?.language}`;
      const response = await httpRequest.delete(url);
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
        getLocationMapData();
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const openDeleteModal = (id) => {
    setLocationToDelete(id);
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="gap-4 grid grid-cols-1 lg:grid-cols-2">
        {locationMap?.map((formDataItem, index) => (
          <div
            key={index}
            className="col-span-1 mt-4 w-full border border-gray-300 bg-white rounded md:rounded-[10px] lg:rounded-[10px] p-3 lg:p-[20px] text-left dark:bg-dark-secondary dark:border-color_dark"
          >
            <div className="gap-2 flex items-center dark:text-color_v1_dark">
              {darkMode ? <HomeIconDark /> : <HomeIcon />}
              <h2 className="flex-1 flex items-center">
                {translate("location.home")}
              </h2>

              <EditIcon
                className="inline-block h-4 w-4  cursor-pointer"
                onClick={() => handleEditLocation(formDataItem._id)}
              />
              <TrashIcon
                className="inline-block h-4 w-4 cursor-pointer"
                // onClick={() => handleDeleteLocation(formDataItem._id)}
                onClick={() => openDeleteModal(formDataItem._id)}
              />
              <ConfirmModalLocation
                isOpen={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                onConfirm={handleDeleteLocation}
              />
            </div>
            <ul className="mt-6 space-y-4 dark:text-color_v1_dark">
              <li>
                <div className="flex items-center gap-2">
                  {darkMode ? <PhoneDark className="h-4 w-4 flex-shrink-0" /> : <CallIcon className="h-4 w-4 flex-shrink-0" />}
                  <span className="flex-grow">{formDataItem?.phone}</span>
                  <LocationIcon className="h-4 w-4 flex-shrink-0" />
                  <span className="flex-grow truncate">
                    {formDataItem?.title}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <LocationIcon className="h-4 w-4 flex-shrink-0" />
                  <span className="flex-grow truncate">
                    {formDataItem?.address}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        ))}
      </div>
    </>
  );
};

export default LocationFormData;
